import { render } from "./DeleteProductModal.vue?vue&type=template&id=4b0dd0bc"
import script from "./DeleteProductModal.vue?vue&type=script&lang=js"
export * from "./DeleteProductModal.vue?vue&type=script&lang=js"

import exportComponent from "C:\\OpenServer\\domains\\jm.loc\\vueapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__